import { render, staticRenderFns } from "./ModalVerDetalleSerTec.vue?vue&type=template&id=1e534130&"
import script from "./ModalVerDetalleSerTec.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleSerTec.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleSerTec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports